module.exports = __webpack_public_path__ + "style/img/壹公里公众号 1.810fd1cb.png";